<template>
    <div class="row">
        <div class="col-auto">

        </div>
    </div>
</template>

<script>
export default {
    name: 'journey-builder-overview-item',
    props: {
        journey: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>

</style>